import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h2 futura bold color="#FF001F" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/pages/Salade-de-Fruits/393011287477279">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Cafe Salade de Fruits Facebook"
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/caf%C3%A9-salade-de-fruits-vancouver">
              <CFImage
                w="45px"
                pr="10px"
                src={yelp}
                alt="Cafe Salade de Fruits Yelp"
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/cafe-salade-de-fruits-fairview-vancouver">
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Cafe Salade de Fruits Zomato"
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/saladedefruitscafe/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Cafe Salade de Fruits Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h2 futura bold color="#FF001F" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/pages/Salade-de-Fruits/393011287477279">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Cafe Salade de Fruits Facebook"
                hover
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/caf%C3%A9-salade-de-fruits-vancouver">
              <CFImage
                w="45px"
                pr="10px"
                src={yelp}
                alt="Cafe Salade de Fruits Yelp"
                hover
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/cafe-salade-de-fruits-fairview-vancouver">
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Cafe Salade de Fruits Zomato"
                hover
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/saladedefruitscafe/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Cafe Salade de Fruits Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
